import { Stack, Typography } from '@mui/material';
import React from 'react';
import CusLink from '../../../../components/material-ui/CusLink';
import { ENUM_USERS_TYPE } from '../../../../enums/enums';
import { useTranslation } from 'react-i18next';

export default function InformationLinks({ selectUserFull }) {
  const { t } = useTranslation();

  const userId = selectUserFull.userId;
  const isGamer = selectUserFull.type == ENUM_USERS_TYPE.gamer;

  const infoLinks = [
    isGamer && {
      id: 'user-finance',
      link: `/users/finance/${userId}/${selectUserFull.currency}`,
      label: 'Financial profile'
    },
    isGamer && { id: 'user-ip', link: `/users/IpAddresses/${userId}`, label: 'User IP addresses' },
    { id: 'user-logs', link: `/users/logs/${userId}/`, label: 'User log' }
  ].filter((el) => el);

  return (
    <Stack gap={1}>
      <Typography fontSize={16} fontWeight={600}>
        {t('Information')}
      </Typography>
      <Stack gap={0.25}>
        {infoLinks.map((el) => (
          <CusLink key={el.id} to={el.link} text={el.label} />
        ))}
      </Stack>
    </Stack>
  );
}
